// @packages
import React, { useEffect, useState } from 'react';
import { StatusBar } from 'expo-status-bar';
import {
  ActivityIndicator,
  Text,
  View
} from 'react-native';

// @scripts
import { useTheme } from '@rneui/themed';
import SchedulesList from '../../components/molecules/schedules-list';
import TestingService from '../../services/testing-service';
import ToggleWithIcon from '../../components/atoms/toggle-with-icon';
import useStyles from './styles';
import { ISchedule, ISession } from '../../utils/types';
import { config } from '../../core/config';
import { useSite } from '../../core/context/siteProvider';

const texts = config.text;

const SiteScheduleDetail = () => {
  const styles = useStyles();
  const { theme } = useTheme();
  const {
    onGoBack,
    site
  } = useSite();

  const currentSiteId = site.siteId;
  const currentSiteName = site.siteName;
  const [isGettingData, setIsGettingData] = useState<boolean>(true);
  const [schedules, setSchedules] = useState<ISchedule[]>([]);
  const [currentSession, setCurrentSession] = useState<ISession|undefined>();

  const getSchedules = async () => {
    setIsGettingData(true);
    try {
      const [_schedules, _currentSession] = await Promise.all([
        TestingService.getSchedule(currentSiteId),
        TestingService.tryGetCurrentSession(currentSiteId)
      ]);
      setSchedules(_schedules);
      setCurrentSession(_currentSession);
    } finally {
      setIsGettingData(false);
    }
  };

  useEffect(() => {
    getSchedules();
    return () => {
      onGoBack();
    };
  }, [currentSiteId]);

  return (
    <View style={styles.container}>
      <Text style={styles.siteName}>{currentSiteName}</Text>
      {isGettingData
        ? <ActivityIndicator size="large" color={theme.colors.grey1} />
        : (
          <>
            <ToggleWithIcon currentSiteId={currentSiteId} initialSession={currentSession} />
            <Text style={styles.title}>{texts.siteScheduleDetail.schedules}</Text>
            <SchedulesList currentSiteId={currentSiteId} schedules={schedules} />
          </>
        )}
      <StatusBar style="auto" />
    </View>
  );
};

export default SiteScheduleDetail;
